import { Component, HostListener, Injector, ViewChild } from "@angular/core";
import { AuthService } from "../../../../services";
import { GlobalErrorHandler } from "../../../../../errorhandler.component";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { ToastrService } from "ngx-toastr";
import { HelperService } from "../../../../services/helperService";
import { Field } from "../../models/field.model";

type ToastType = "show" | "success" | "error" | "warning" | "info";

@Component({
	selector: "tig-form-inlineiframe",
	templateUrl: "./form-inlineiframe.component.html",
	styleUrls: ["./form-inlineiframe.component.scss"],
})
export class FormInlineiframeComponent extends Field {
	@ViewChild("OBJ_model_iframe", { static: false }) OBJ_model_iframe;

	/**
	 * Attributes
	 */
	private OBJ_auth_service: AuthService;

	/**
	 * @param OBJ_injector
	 * @param OBJ_helper_service
	 * @param OBJ_toastr_service
	 * @param OBJ_loading_spinner
	 */
	constructor(
		private OBJ_injector: Injector,
		private OBJ_helper_service: HelperService,
		private OBJ_toastr_service: ToastrService,
		private OBJ_loading_spinner: Ng4LoadingSpinnerService
	) {
		super();
	} // end constructor

	/**
	 * Function > getIFrameID
	 */
	public getIFrameID() {
		return "";
	} // end function getIFrameID

	/**
	 * Function > onMessage
	 * @desc Listen to messages from iframe
	 *
	 * @param event
	 */
	@HostListener("window:message", ["$event"])
	onMessage(event) {
		if (event.source.frameElement !== null && event.source.frameElement.id === this.getIFrameID()) {
			this.receiveMessageFromIFrame(event);
		}
	} // end function onMessage

	@HostListener("window:scroll", ["$event"]) // for window scroll events
	onScroll(event) {
		const iFrame = document.getElementById(this.getIFrameID());
		const distanceTop = iFrame.getBoundingClientRect().top;

		(iFrame as any).contentWindow.postMessage(distanceTop);
	}

	/**
	 *
	 * @param event
	 */
	protected receiveMessageFromIFrame(event: any) {
		this.OBJ_auth_service = this.OBJ_injector.get(AuthService);
		try {
			// try to parse the event we got
			let OBJ_data = event.data;

			switch (OBJ_data.event) {
				case "ready":
					// post message to iFrame
					let OBJ_msg = {
						event: "config",
						access_token:
							this.OBJ_helper_service.getFromLocalstorage(
								"access"
							).access_token,
						refresh_token:
							this.OBJ_helper_service.getFromLocalstorage(
								"access"
							).refresh_token,
						network:
							this.OBJ_helper_service.getFromLocalstorage(
								"client"
							).network,
					};

					// Post data to iFrame
					event.source.postMessage(OBJ_msg, "*");

					break;

				case "copyToClipboard":
					this.OBJ_helper_service.copyStringToClipboard(OBJ_data.message.content, "");
					break;
				// iFrame Triggers Loadingspinner
				case "isLoading":
					this.OBJ_loading_spinner.show();
					break;

				case "doneLoading":
					this.OBJ_loading_spinner.hide();
					break;

				case "showToast":
					switch (OBJ_data.message.type as ToastType) {
						case "error":
							this.OBJ_toastr_service.error(
								OBJ_data.message.message,
								OBJ_data.message.title
							);
							break;
						case "warning":
							this.OBJ_toastr_service.warning(
								OBJ_data.message.message,
								OBJ_data.message.title
							);
							break;
						case "info":
							this.OBJ_toastr_service.info(
								OBJ_data.message.message,
								OBJ_data.message.title
							);
							break;
						case "show":
							this.OBJ_toastr_service.show(
								OBJ_data.message.message,
								OBJ_data.message.title
							);
							break;
						case "success":
							this.OBJ_toastr_service.success(
								OBJ_data.message.message,
								OBJ_data.message.title
							);
							break;
						default:
							this.OBJ_toastr_service.show(
								OBJ_data.message.message,
								OBJ_data.message.title
							);
							break;
					}
					break;

				case "resizeIFrame":
					const newSize = OBJ_data.message.size;
					// 60px is a rule of thumb for browser compatibility
					document.getElementById(
						this.getIFrameID()
					).style.height = `${parseInt(newSize, 10) + 60}px`;
					break;

				case "refreshToken":
					this.OBJ_auth_service.refreshToken().subscribe((data) => {
						const msg = {
							proxyMessageID: OBJ_data.proxyMessageID,
							message: data,
							recipient: OBJ_data.sender
								? OBJ_data.sender
								: "UFC", // Fallback solution, TODO
						};
						event.source.postMessage(msg, "*");
					});
					break;

				case "generate_hash":
					let OBJ_hash = this.OBJ_helper_service.generateHash(
						OBJ_data.params,
						OBJ_data.body,
						this.OBJ_auth_service.getToken("access_token")
					);
					// Post data to iFrame
					event.source.postMessage(OBJ_hash, event.origin);
					break;
				case "getTokens":
					const {
						access_token: accessToken,
						refresh_token: refreshToken,
					} = this.OBJ_helper_service.getFromLocalstorage("access");
					const answer = {
						proxyMessageID: OBJ_data.proxyMessageID,
						recipient: OBJ_data.sender,
						message: { accessToken, refreshToken },
					};
					event.source.postMessage(answer, "*");
					break;
				case "getConfig":
					const config =
						this.OBJ_helper_service.getFromLocalstorage("client");

					event.source.postMessage(
						{
							proxyMessageID: OBJ_data.proxyMessageID,
							recipient: OBJ_data.sender,
							message: {
								application: config.id,
								network: config.network.toString(),
							},
						},
						"*"
					);
					break;
			} // end switch
		} catch (e) {
			// Not the event we are looking for, no need to take action
		} // end try/catch
	}
}
